<script setup>
import {onMounted, ref, defineProps, defineEmits, computed, nextTick, watch} from 'vue'

const emit = defineEmits([ "file" ]);

const props = defineProps({
  clear: {
    type: Boolean,
    default: true
  }
});

// Handler for file selection
function handleFileChange(event) {
  const file = event.target.files[0];
  if (file) {
    emit("file", file)
  }
}

// Set up the event listener once on mount
onMounted(() => {
  const fileInput = document.getElementById('fileinput');
  if (fileInput) {
    fileInput.addEventListener('change', handleFileChange);
  }
})

function c() {
  const fileInput = document.getElementById('fileinput');

  if (props.clear) fileInput.value = null;

  fileInput.click(); // open the file dialog
}

</script>


<template>
  <div class="b" @click="c">
    
    <slot/>
    <input type="file" id="fileinput" style="display:none;"/>
  </div>
</template>

<style scoped>

.b {
  background-color: #1E252F;
  border-radius: 10px;
  padding: .6rem 1.6rem;
  display: inline-block;
  transition: all .1s ease; 
}

.b:hover {
  cursor: pointer;
  color: white;
  background-color: #222a35;
}

.b.blue {
  background-color: #4587e7;
  color: white;
}

.b.blue:hover {
  background-color: #5B94E6
}

</style>
